import {PageContent} from './../shared/classes/page-content.model';
import {Component, OnInit, Input, OnChanges} from '@angular/core';
import {RightSideService} from '../shared/right-side.service';
import {NavigationBarService} from '../shared/navigation-bar.service';
import {storageFactory} from '../../../app-storage';

@Component({
  selector: 'app-right-section',
  templateUrl: './right-section.component.html',
  styleUrls: ['./right-section.component.css']
})
export class RightSectionComponent implements OnInit, OnChanges {
  @Input() selectedTab: number;
  totalPrice: number;
  productDescription: string;
  resetChanges = true;
  pageContent: PageContent;
  imageUrl: string;
  isIOS: boolean;

  constructor(public tabService: RightSideService,
              private navBarService: NavigationBarService) {
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
  }

  ngOnInit() {
    this.tabService.merchantChange.subscribe((value) => {
      this.totalPrice = this.tabService.getPrice();
      this.resetChanges = false;
    });
    this.tabService.labelChange.subscribe((value) => {
      this.productDescription = this.tabService.getLabel();
      this.resetChanges = false;
    });
    this.tabService.imageUrlChange.subscribe((value) => {
      this.imageUrl = this.tabService.getImageUrl();
    });
    this.tabService.resetChangesEvent.subscribe((value) => {
      this.resetChanges = this.tabService.getResetChanged();
    });
    this.navBarService.selectedTabChange.subscribe(val => {
      this.selectedTab = this.navBarService.getSelectedTab();
    });
    this.tabService.pageContentChange.subscribe(val => {
      this.pageContent = this.tabService.getPageContent();
    });
  }

  ngOnChanges() {
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/right-section/right-section.component.ts